const actions = {
  SCHEDULE_CLASS_BY_TEACHER_REQUEST: "SCHEDULE_CLASS_BY_TEACHER_REQUEST",
  SCHEDULE_CLASS_BY_TEACHER_SUCCESS: "SCHEDULE_CLASS_BY_TEACHER_SUCCESS",
  SCHEDULE_CLASS_BY_TEACHER_ERROR: "SCHEDULE_CLASS_BY_TEACHER_ERROR",
  RESET_SESSIONS: "RESET_SESSIONS",
  teacherSchedule: () => ({
    type: actions.SCHEDULE_CLASS_BY_TEACHER_REQUEST,
  }),
};
export default actions;
